import React, { useState } from "react";
import { Tooltip } from 'react-tooltip';
//Components
import { VisibilityConditional } from "components/VisibilityConditional";
import { IsNullOrEmpty } from "utils/StringNullOrEmpty";
import toast from "components/Toast/dispatch";
import Table from "components/Table";
//Services
import QuoteBionexoServices from "services/quoteBionexo.service";
//context
import { useDetailsQuoteContext } from "contexts/DetailsQuote";
//Assets
import historyDownloadOrderBlockedIcon from 'img/history-download-order-blocked.svg';
import orderMirrorDownloadIcon from 'img/order-mirror-download-icon.svg';
import orderMirrorDownloadBlockedIcon from 'img/order-mirror-download-icon-blocked.svg';
import historyDownloadOrderIcon from 'img/history-download-order.svg';
//Interfaces
import { downloadOrderModel } from "pages/Quotes/MoneyRecordedQuotes/models";
import { IPreOrders } from "../Dropdown/PortalOrderDropdown/interface";
import { OrderMirrorButtonProps } from "./interface";
//Generics
import { generateRandomId } from "utils/GenerateRandomId";
//utils
import { handleCreatePdf } from "pages/Quotes/Dashboard/utils";
import { toastify } from "components/Toastify/utils";
//styles
import { IconContent, PreOrderButton, Loading } from "./styles";

export const OrderMirrorButton: React.FC<OrderMirrorButtonProps> = (props) => {
  const { viewed, quotationCode, distributionCenter, sequenceNumbers } = props;

  const { order, preOrderDetails, setOrder, setFinishUpdateOrder } = useDetailsQuoteContext();

  const [isDownloading, setIsDownloading] = useState(false);

  const _quoteBionexoServices = new QuoteBionexoServices();

  const tooltipId = generateRandomId("TooltipOrderMirror");

  const mirrorButton = () => (
    <PreOrderButton
      tooltip={(IsNullOrEmpty(sequenceNumbers) || sequenceNumbers?.length > 0) ? "Baixar espelho do pedido" : "Espelho não disponível, itens cancelados."}
      onClick={() => (IsNullOrEmpty(sequenceNumbers) || sequenceNumbers?.length > 0) && handleDownloadPreOrderMirror()}
    >
      <img alt="order mirror download icon" src={(IsNullOrEmpty(sequenceNumbers) || sequenceNumbers?.length > 0) ? orderMirrorDownloadIcon : orderMirrorDownloadBlockedIcon} />
    </PreOrderButton>
  );

  const loader = () => (
    <Loading withPadding={false} size={16} />
  );

  const refreshOrder = () => {
    if (order && order.data) {
      const newOrder = { ...order };
      const index = newOrder!.data!.findIndex((x: any) => x.code === quotationCode);

      preOrderDetails?.map((x: IPreOrders) => {
        if (x.distributionCenter === distributionCenter && x.sequenceNumbers === sequenceNumbers)
          x.isRecent = false;
      });

      const preOrderIsRecent = preOrderDetails!.filter((x: IPreOrders) => x.isRecent);
      if (index !== -1) {
        newOrder.data![index]!.isRead = true;
        newOrder.data![index]!.isRecent = preOrderIsRecent.length > 0;

        setOrder(newOrder);
        setFinishUpdateOrder(true);
        setIsDownloading(false);
      }
    }
  };

  const handleDownloadPreOrderMirror = async () => {
    setIsDownloading(true);
    const response = await _quoteBionexoServices.downloadPreOrderDetails(quotationCode, distributionCenter, sequenceNumbers);

    if (response.status === 200) {
      handleCreatePdf(response, "Espelho-Pedido", undefined, quotationCode, distributionCenter, true);
      await _quoteBionexoServices.preOrderDownloadedRead(quotationCode, distributionCenter, sequenceNumbers, true);

      refreshOrder();
    } else
      toastify.error('Ocorreu um erro durante a requisição');
  };

  const renderListDownload = () => (
    <Table
      tableOrder=""
      rowHeight={25}
      totalPages={1}
      currentPage={0}
      portalCustomHeader
      onReload={() => { }}
      setTableOrder={() => { }}
      data={viewed ?? undefined}
      model={downloadOrderModel}
      pageSize={viewed?.length ?? 1}
      trackingKey="Detalhes dos download de pedidos"
    />
  );

  const viewedUsersDownloadOrder = () => {
    toast.withComponent("Histórico de downloads", renderListDownload(), "Fechar", 20);
  };

  const messageTooltipHistoryPreOrder = sequenceNumbers?.length === 0 ? "Histórico não disponível, itens cancelados" : viewed && viewed.length > 0 ? "Visualizar histórico de download" : "Sem histórico de download";

  return (
    <IconContent>
      <VisibilityConditional
        condition={isDownloading}
        firstOption={loader}
        secondOption={mirrorButton}
      />

      <PreOrderButton
        tooltip={messageTooltipHistoryPreOrder}
        onClick={() => (viewed && viewed.length > 0 && (IsNullOrEmpty(sequenceNumbers) || sequenceNumbers?.length > 0)) && viewedUsersDownloadOrder()}
      >
        <img alt="history download order icon" src={viewed && viewed.length > 0 && (IsNullOrEmpty(sequenceNumbers) || sequenceNumbers?.length > 0) ? historyDownloadOrderIcon : historyDownloadOrderBlockedIcon} />
      </PreOrderButton>

      <Tooltip id={tooltipId} variant="light" />
    </IconContent>
  );
};